function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.93,16.87l-.28-.54a9.82,9.82,0,0,0-1.48-2.44,1.17,1.17,0,0,0-1.39-.24,4,4,0,0,0-.7.59,2.36,2.36,0,0,1-1.51.51h-.49a2.37,2.37,0,0,1-1.54-.52,4.45,4.45,0,0,0-.71-.59,1.28,1.28,0,0,0-1.52.24,11.62,11.62,0,0,0-1.54,2.35v.07a1.61,1.61,0,0,1,1.6.44,12.46,12.46,0,0,1,.88,1.18h7.9a1.07,1.07,0,0,0,.88-.3A1,1,0,0,0,29.93,16.87Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.81,20.1l-.27-.56A9.66,9.66,0,0,0,20,17.11a1.17,1.17,0,0,0-1.38-.25,4,4,0,0,0-.71.59,2.44,2.44,0,0,1-1.54.51h-.49a2.43,2.43,0,0,1-1.56-.52,4.88,4.88,0,0,0-.69-.59,1.25,1.25,0,0,0-1.51.24,10.64,10.64,0,0,0-1.58,2.35l-.11.22a1.56,1.56,0,0,1,1.54.46,9.77,9.77,0,0,1,.76,1.06H21a1.09,1.09,0,0,0,.93-.32A1,1,0,0,0,21.81,20.1Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94,24.61A1.19,1.19,0,0,1,2,24.28c-.16-.21,0-.61,0-.84l.26-.56a11.74,11.74,0,0,1,1.54-2.41,1.26,1.26,0,0,1,1.51-.24,4.9,4.9,0,0,1,.7.58,2.36,2.36,0,0,0,1.5.52H8a2.36,2.36,0,0,0,1.54-.5,3.33,3.33,0,0,1,.71-.59,1.19,1.19,0,0,1,1.39.23,10.3,10.3,0,0,1,1.44,2.46l.27.54a1.06,1.06,0,0,1,.09.85,1.11,1.11,0,0,1-.93.3Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09,16.31a3.45,3.45,0,0,0,3.24-3.62V12.6a3.34,3.34,0,0,0-3.24-3.41H16a3.35,3.35,0,0,0-3.18,3.5v0A3.46,3.46,0,0,0,16.09,16.31Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78,19.65A3.45,3.45,0,0,0,11,16V16a3.32,3.32,0,0,0-3.22-3.41h0A3.3,3.3,0,0,0,4.61,16h0A3.53,3.53,0,0,0,7.78,19.65Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.24,13.1a3.46,3.46,0,0,0,3.29-3.62V9.43h0A3.32,3.32,0,0,0,24.31,6h-.07a3.32,3.32,0,0,0-3.19,3.44h0A3.46,3.46,0,0,0,24.24,13.1Z",
    style: {
      fill: "#e54918"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2c40fba3.svg";
export { ForwardRef as ReactComponent };